export default __webpack_public_path__ + "static/media/arrow-down-and-up.264fa9d4.svg";